var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"vue-moments-ago"},[_vm._v("\n  "+_vm._s(_vm.prefix)+" "+_vm._s(_vm._f("plural")(_vm.humanDifference,_vm.humanWord, _vm.language))+" "+_vm._s(_vm.language == 'kr' ? '전' : 'ago')+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e76028","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cowork/common/momentAgo/MomentAgo.vue
// module id = null
// module chunks = 